import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function RandevuPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    date: '',
    time: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-cream to-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-navy/5 to-gold/5"></div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="font-serif text-5xl md:text-6xl font-bold text-primary-dark mb-6">
              Online Randevu
            </h1>
            <p className="text-lg text-text-secondary leading-relaxed">
              Astrolojik danışmanlık, spiritüel rehberlik veya enerji şifası seansı için 
              randevu oluşturun. Size en uygun tarih ve saati birlikte belirleyelim.
            </p>
          </div>
        </div>
      </section>

      {/* Appointment Form */}
      <section className="py-16">
        <div className="max-w-5xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Info Sidebar */}
            <div className="lg:col-span-1">
              <div className="bg-gradient-to-br from-primary-navy to-primary-dark rounded-2xl p-8 text-white sticky top-24">
                <h3 className="font-serif text-2xl font-bold mb-6">Randevu Bilgileri</h3>
                
                <div className="space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-gold/20 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-time-line text-gold"></i>
                    </div>
                    <div>
                      <h4 className="font-medium mb-1">Seans Süresi</h4>
                      <p className="text-sm text-text-light">60-90 dakika arası</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-gold/20 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-computer-line text-gold"></i>
                    </div>
                    <div>
                      <h4 className="font-medium mb-1">Format</h4>
                      <p className="text-sm text-text-light">Yüz yüze veya Online (Zoom/Google Meet/WhatsApp vb.) olarak tercih edebilirsiniz</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-gold/20 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-calendar-check-line text-gold"></i>
                    </div>
                    <div>
                      <h4 className="font-medium mb-1">Onay Süreci</h4>
                      <p className="text-sm text-text-light">24 saat içinde onaylanır</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-gold/20 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-shield-check-line text-gold"></i>
                    </div>
                    <div>
                      <h4 className="font-medium mb-1">Gizlilik</h4>
                      <p className="text-sm text-text-light">Tüm görüşmeler gizlidir</p>
                    </div>
                  </div>
                </div>

                <div className="mt-8 pt-8 border-t border-white/20">
                  <p className="text-sm text-text-light mb-4">
                    Acil durumlar için doğrudan iletişime geçin:
                  </p>
                  <a
                    href="https://wa.me/905555555555"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="flex items-center justify-center gap-2 w-full px-6 py-3 bg-gold text-primary-dark rounded-full font-medium hover:shadow-lg hover:shadow-gold/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-line text-lg"></i>
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>

            {/* Form */}
            <div className="lg:col-span-2">
              <div className="bg-white rounded-2xl shadow-xl p-8">
                <h2 className="font-serif text-3xl font-bold text-primary-dark mb-8">
                  Randevu Formu
                </h2>

                {submitted && (
                  <div className="mb-6 p-4 bg-gold/10 border border-gold/30 rounded-lg">
                    <p className="text-sm text-primary-dark flex items-center gap-2">
                      <i className="ri-checkbox-circle-fill text-gold"></i>
                      Randevu talebiniz alınmıştır. 24 saat içinde size dönüş yapılacaktır.
                    </p>
                  </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-primary-dark mb-2">
                        Ad Soyad *
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 border border-gold/30 rounded-lg focus:outline-none focus:border-gold transition-colors duration-300 text-sm"
                        placeholder="Adınız ve soyadınız"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-primary-dark mb-2">
                        E-posta *
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 border border-gold/30 rounded-lg focus:outline-none focus:border-gold transition-colors duration-300 text-sm"
                        placeholder="ornek@email.com"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-primary-dark mb-2">
                      Telefon *
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gold/30 rounded-lg focus:outline-none focus:border-gold transition-colors duration-300 text-sm"
                      placeholder="+90 555 555 55 55"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-primary-dark mb-2">
                      Hizmet Seçimi *
                    </label>
                    <select
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gold/30 rounded-lg focus:outline-none focus:border-gold transition-colors duration-300 text-sm cursor-pointer"
                    >
                      <option value="">Hizmet seçiniz</option>
                      <option value="dogum-haritasi">Doğum Haritası Analizi</option>
                      <option value="sinastri">Sinastri / İlişki Uyumu</option>
                      <option value="yillik-ongoru">Yıllık Öngörü / Transit</option>
                      <option value="kariyer">Kariyer & Para Danışmanlığı</option>
                      <option value="spiritual">Spiritüel Rehberlik</option>
                      <option value="enerji">Enerji Çalışmaları</option>
                    </select>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-primary-dark mb-2">
                        Tercih Edilen Tarih *
                      </label>
                      <input
                        type="date"
                        name="date"
                        value={formData.date}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 border border-gold/30 rounded-lg focus:outline-none focus:border-gold transition-colors duration-300 text-sm cursor-pointer"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-primary-dark mb-2">
                        Tercih Edilen Saat *
                      </label>
                      <select
                        name="time"
                        value={formData.time}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 border border-gold/30 rounded-lg focus:outline-none focus:border-gold transition-colors duration-300 text-sm cursor-pointer"
                      >
                        <option value="">Saat seçiniz</option>
                        <option value="09:00">09:00</option>
                        <option value="10:30">10:30</option>
                        <option value="12:00">12:00</option>
                        <option value="14:00">14:00</option>
                        <option value="15:30">15:30</option>
                        <option value="17:00">17:00</option>
                        <option value="18:30">18:30</option>
                        <option value="20:00">20:00</option>
                      </select>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-primary-dark mb-2">
                      Ek Notlar
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows={4}
                      maxLength={500}
                      className="w-full px-4 py-3 border border-gold/30 rounded-lg focus:outline-none focus:border-gold transition-colors duration-300 text-sm resize-none"
                      placeholder="Randevunuzla ilgili özel bir notunuz varsa buraya yazabilirsiniz..."
                    ></textarea>
                    <p className="text-xs text-text-secondary mt-1">
                      Maksimum 500 karakter
                    </p>
                  </div>

                  <div className="pt-4">
                    <button
                      type="submit"
                      className="w-full px-8 py-4 bg-gold text-primary-dark rounded-full font-medium text-lg hover:shadow-lg hover:shadow-gold/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
                    >
                      Randevu Talebi Gönder
                    </button>
                    <p className="text-xs text-text-secondary text-center mt-4">
                      Randevu talebiniz 24 saat içinde onaylanacak ve size bilgi verilecektir.
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}